export default __webpack_public_path__ + "static/media/105-profile.f3892e9e.svg";